/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

export default isInteger;



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/polyfills/isInteger.mjs
// module id = 3374
// module chunks = 0